import React, {useEffect} from "react";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import {FormControl} from "@mui/material";
import RadioGroup from "@mui/material/RadioGroup";
import Radio from "@mui/material/Radio";
import Typography from "@mui/material/Typography";

interface TikTokFormProps {
    onFieldChange: (field: string, value: string) => void;
    onFieldBlur?: (field: string, value: string) => void;
    tikTokFormState: TikTokFormState
    disableCompilationFields?: boolean
}

export interface TikTokFormState {
    title: string;
    privacy_level: string;
}

const privacyLevelsOptions = [
    {
        id: "PUBLIC_TO_EVERYONE",
        value: "Public to every one"
    },
    {
        id: "MUTUAL_FOLLOW_FRIENDS",
        value: "Mutual follow friends"
    },
    {
        id: "SELF_ONLY",
        value: "Self Only"
    }
]

const TikTokForm: React.FC<TikTokFormProps> = ({
                                                     onFieldChange,
                                                     onFieldBlur, // Destrutturiamo la nuova prop
                                                     tikTokFormState,
                                                     disableCompilationFields = false
                                                 }) => {

    const handleBlur = (field: string, value: string) => {
        if (onFieldBlur) {
            onFieldBlur(field, value);
        }
    };

    return (
        <Grid container spacing={2}>
            <Grid size={{ md: 12, lg: 12 }}>
                <Box display="flex" flexDirection={'column'}>
                    <TextField
                        value={tikTokFormState.title}
                        name={"tikTokTitle"}
                        placeholder={"Insert title"}
                        type={'text'}
                        variant={'outlined'}
                        onChange={(e) => onFieldChange('title', e.target.value)}
                        onBlur={(e) => handleBlur('title', e.target.value)}
                        fullWidth
                        sx={{ mb: 2 }}
                        disabled={disableCompilationFields}
                    />
                    <FormControl
                        fullWidth
                        disabled={disableCompilationFields}
                        sx={{
                            flexDirection: 'row',
                            alignItems: 'center',
                            gap: 2
                        }}
                    >
                        <Typography>Privacy Level:</Typography>

                        <RadioGroup
                            row
                            aria-labelledby="radio-buttons-group-label"
                            name="tikTokPrivacyLevel"
                            value={tikTokFormState.privacy_level}
                            onChange={(e) => onFieldChange('privacy_level', e.target.value)}
                        >
                            {privacyLevelsOptions.map((item) => (
                                <FormControlLabel
                                    key={item.id}
                                    value={item.id}
                                    control={<Radio />}
                                    label={item.value}
                                />
                            ))}
                        </RadioGroup>
                    </FormControl>
                </Box>
            </Grid>
        </Grid>
    )
}

export default TikTokForm;